<template>
  <div class="cont">
    <Menu />
    <div class="contBx">
      <div class="breadNav">
        <router-link target="_self" to="/resourceCenter">资讯</router-link>
        <span class="angle" v-if="title"> > </span>
        <span v-if="title">{{ title }}</span>
        <span class="angle" v-if="news_list.length == 0"> > 暂无数据</span>
      </div>
      <div class="list" v-if="news_list.length > 0">
        <div class="listItem" v-for="(item, index) in news_list" :key="index">
          <router-link target="_self" :to="`/news/${item.id}`" class="itemImg">
            <img
              class="pic"
              :src="item.article_image"
              :alt="item.article_title"
            />
          </router-link>
          <div class="itemCont">
            <router-link
              target="_self"
              :to="`/news/${item.id}`"
              class="itemTitle"
            >
              <h2>{{ item.article_title }}</h2>
            </router-link>
            <div class="itemInfo">
              <img src="@/assets/menu/logo.svg" class="itemLogo" alt="ToDesk" />
              <p class="itemTime">{{ item.release_time | formatTime }}</p>
            </div>
          </div>
        </div>
      </div>
      <infinite-loading @infinite="infiniteHandler">
        <span class="no_more" slot="no-more">没有更多了哦</span>
      </infinite-loading>
    </div>
    <Footer />
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import InfiniteLoading from "vue-infinite-loading";
export default {
  components: {
    Menu,
    Footer,
    InfiniteLoading,
  },
  data() {
    return {
      news_list: [],
      tag_id: "",
      offset: 0,
      title: "",
    };
  },
  created() {
    this.tag_id = this.$route.query.tag_id;
    this.title = this.$route.query.title;
  },
  methods: {
    infiniteHandler($state) {
      this.$serve
        .getNews({
          tag_id: this.tag_id,
          offset: this.offset,
          limit: 8,
        })
        .then((res) => {
          if (res.data.list.length) {
            this.offset = this.offset + 8;
            this.news_list = this.news_list.concat(res.data.list);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
    },
  },
  filters: {
    formatTime(data) {
      return data.split(".")[0].split("T")[0];
    },
  },
};
</script>
<style lang="less" scoped>
.cont {
  background: #fff;
  .contBx {
    margin: auto;
    padding-left: 15px;
    padding-right: 15px;
    box-sizing: border-box;
    padding-bottom: 20px;
    .breadNav {
      display: flex;
      align-items: center;
      padding-top: 20px;
      padding-bottom: 20px;
      color: #0070f9;
      font-size: 16px;
      .angle {
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    .list {
      .listItem {
        box-shadow: 0px 6px 8px 0px #e6e8eb;
        border: 1px solid #e6e8eb;
        display: flex;
        margin-bottom: 20px;
        padding: 10px;
        border-radius: 6px;
        align-items: center;
        .itemImg {
          display: block;
          .pic {
            display: block;
            width: 60px;
            height: auto;
            margin-right: 10px;
          }
        }
        .itemCont {
          flex: 1;
          height: 100%;
          overflow: hidden;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .itemTitle {
            -webkit-line-clamp: 2;
            font-size: 14px;
            word-wrap: break-word;
            word-break: break-all;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            margin-bottom: 10px;
            color: #3a3e45;
          }
          .itemInfo {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .itemLogo {
              height: 17px;
              width: auto;
            }
            .itemTime {
              margin-left: 30px;
              color: #999999;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  .no_more {
    color: #999999;
    font-size: 12px;
  }
}
</style>
